import React, { useState } from 'react';
import { FaWhatsapp } from "react-icons/fa";
import './Quote.css';

export function Quote() {
  const [formData, setFormData] = useState({
    name: '',
    phone: '',
    pickup: '',
    dropoff: '',
    date: '',
    items: '',
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  //   const handleSubmit = (e) => {
  //     e.preventDefault();
  //     const whatsappMessage = `Hello! I would like to request a quote. Here are my details:
  // - Name: ${formData.name}
  // - Phone: ${formData.phone}
  // - Pickup Location: ${formData.pickup}
  // - Dropoff Location: ${formData.dropoff}
  // - Date: ${formData.date}
  // - Items: ${formData.items || 'No description provided'}
  //     `;

  //     const whatsappURL = `https://wa.me/919625581855?text=${encodeURIComponent(
  //       whatsappMessage
  //     )}`;
  //     window.open(whatsappURL, '_blank');
  //   };



  const handleSubmit = (e) => {
    e.preventDefault();

    const whatsappMessage = `Hello! I would like to request a quote.%0A%0A
  Name: ${formData.name}%0A
  Phone: ${formData.phone}%0A
  Pickup Location: ${formData.pickup}%0A
  Dropoff Location: ${formData.dropoff}%0A
  Date: ${formData.date}%0A
  Items: ${formData.items || 'No description provided'}%0A`;

    const whatsappURL = `https://wa.me/919625581855?text=${whatsappMessage}`;

    window.open(whatsappURL, '_blank');
  };


  return (
    <div className="quote">
      <h2>Get a Free Quote</h2>
      <form onSubmit={handleSubmit}>
        <input
          type="text"
          name="name"
          placeholder="Your Name"
          value={formData.name}
          onChange={handleChange}
          required
        />
        <input
          type="text"
          name="phone"
          placeholder="Phone Number"
          value={formData.phone}
          onChange={handleChange}
          required
        />
        <div className="row">
          <input
            type="text"
            name="pickup"
            placeholder="Pickup Location"
            value={formData.pickup}
            onChange={handleChange}
            required
          />
          <input
            type="text"
            name="dropoff"
            placeholder="Dropoff Location"
            value={formData.dropoff}
            onChange={handleChange}
            required
          />
        </div>
        <input
          type="date"
          name="date"
          value={formData.date}
          onChange={handleChange}
          required
        />
        <textarea
          name="items"
          placeholder="Describe Items (optional)"
          value={formData.items}
          onChange={handleChange}
        ></textarea>
        <button type="submit" className="whatsapp-button">
          <FaWhatsapp className="whatsapp-icon" /> Submit
        </button>
      </form>
    </div>
  );
}
